var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-days"},[_vm._v(" "+_vm._s(_vm.formattedString)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }